module.exports = __webpack_public_path__ + "static/media/Icons-29.9ce35fb0.png";